// src/components/CookieBanner.tsx
import { useEffect, useState } from 'react';
import ReactGA from 'react-ga4';
import CookiesIcon from '../assets/images/CookiesIcon';
import { useNavigate } from 'react-router-dom';

const measurementId = 'G-3L3WYS8RE8';

const CookieBanner = () => {
    const [show, setShow] = useState(false);
    const nav = useNavigate();
    useEffect(() => {
        const consent = localStorage.getItem('cookie_consent');
        if (!consent) setShow(true);
    }, []);

    const handleAccept = () => {
        localStorage.setItem('cookie_consent', 'true');
        ReactGA.initialize(measurementId);
        ReactGA.send({ hitType: 'pageview', page: window.location.pathname + window.location.search });
        setShow(false);
    };

    const handleDecline = () => {
        localStorage.setItem('cookie_consent', 'false');
        setShow(false);
    };

    if (!show) return null;

    return (
        <div className="fixed lg:bottom-10 max-lg:top-1/2 max-lg:-translate-y-1/2 left-1/2 -translate-x-1/2 lg:bg-[#0000007D] max-lg:bg-black max-lg:bg-opacity-60 max-lg:border max-lg:border-white p-8 rounded-2xl z-50 animate-fadeIn max-lg:w-[95%]">
            <div className="lg:flex items-start lg:gap-x-4 max-lg:space-y-4 ">
                <div className="max-lg:mx-auto w-fit">
                    <CookiesIcon />
                </div>
                <div className="-mt-4 max-lg:text-center">
                    <p className="font-bold lg:text-[48px] text-[32px] font-inter text-white">
                        We use cookies
                    </p>
                    <p className="text-[16px] font-inter text-white">This helps us ensure a smooth experience and improve our app for you.</p>
                    <p className="text-[16px] font-inter text-white underline cursor-pointer" onClick={() => { nav("/legal") }}>Learn more</p>
                </div>
            </div>
            <div className="mt-4 flex lg:justify-end max-lg:justify-between gap-2">
                <button
                    className="bg-[#0000007D] backdrop-blur-[27.6] px-2 py-4 rounded-2xl transition text-base text-white min-w-[100px]"
                    onClick={handleDecline}
                >
                    Decline
                </button>
                <button
                    className="bg-[#8AC028] backdrop-blur-[27.6] px-2 py-4 rounded-2xl transition text-base text-white font-bold min-w-[120px]"
                    onClick={handleAccept}
                >
                    Allow Cookies
                </button>
            </div>
        </div>
    );
};

export default CookieBanner;
